import { useCallback, useMemo, useState } from "react";
import { CustomerEditDrawer } from "../customer-drawer/CustomerEditDrawer";
import { CustomerProfileLauncherContext } from "./CustomerProfileLauncherContext";

export function CustomerProfileOverlayProvider({ children }) {
  const [customer, setCustomer] = useState(null);
  const [zIndex, setZIndex] = useState(undefined);
  const [editorOptions, setEditorOptions] = useState({});
  const [request, setRequest] = useState(0);

  const openCustomerProfile = useCallback((nextCustomer, options) => {
    if (nextCustomer) { setZIndex(options?.zIndex); setEditorOptions(options || {}); setRequest(value => value + 1); setCustomer(nextCustomer); }
  }, []);

  const closeCustomerProfile = useCallback(() => setCustomer(null), []);
  const value = useMemo(() => ({ openCustomerProfile, closeCustomerProfile }), [openCustomerProfile, closeCustomerProfile]);

  return (
    <CustomerProfileLauncherContext.Provider value={value}>
      {children}
      <CustomerEditDrawer
        key={request}
        defaultCreateOpen={editorOptions.defaultCreateOpen}
        editDraftPk={editorOptions.editDraftPk}
        imageMessages={editorOptions.imageMessages}
        imageMessagesLoading={editorOptions.imageMessagesLoading}
        onQueryCreated={editorOptions.onQueryCreated}
        onQuerySaved={editorOptions.onQuerySaved}
        onQueryReload={editorOptions.onQueryReload}
        customer={customer}
        open={!!customer}
        defaultTab="customer"
        placement="right"
        zIndex={zIndex}
        onClose={closeCustomerProfile}
        onSaved={updated => setCustomer(updated)}
        onFieldChanged={patch => setCustomer(current => current ? { ...current, ...patch } : current)}
      />
    </CustomerProfileLauncherContext.Provider>
  );
}
